/*
 * @Author: wzh
 * @LastEditTime: 2023-07-04 16:08:07
 * @Description:
 */
import authRoutes from "../routes/auth.routes";
import { isMobile } from "@/utils/helpers";
import { getUrlParam } from "@/utils";
import VueCookies from "vue-cookies";
import {
	readCookie,
	hasActiveLoginSession,
	hasValidUserContext,
	clearStaleAuthCookies,
} from "@/utils/authSession";

/**
 * 登录状态守卫
 * 支持普通会话与 7 天免登录（REMEMBER_ME）
 * @typedef beforeGuard
 */
export function loginStateGuard(to, from, next) {
	let isLogin = hasActiveLoginSession(VueCookies);
	const congressCookie = readCookie("congress");
	let redirect_uri = getUrlParam("redirect_uri");

	// 仅有失效 congress、且无 7 天免登录可恢复时，清理会话 cookie（保留 REMEMBER_ME）
	if (congressCookie && !hasValidUserContext(VueCookies)) {
		clearStaleAuthCookies(VueCookies);
		isLogin = hasActiveLoginSession(VueCookies);
	}

	// 如果没有登录且访问了非 auth 模块的路由，重定向到登录页
	if (!isLogin && !inAuthRoutes(to.path) && !to.meta.notRequireAuth) {
		localStorage.removeItem("token");
		localStorage.removeItem("user");
		sessionStorage.removeItem("token");
		sessionStorage.removeItem("user");
		const path = isMobile() ? "/mlogin" : "/authserver/login";
		next(path);
	} else if (isLogin && to.path.includes("login")) {
		// 登录过后直接访问登录页，重定向到首页
		if (redirect_uri) {
			console.log("redirect_uri---login", redirect_uri);
			localStorage.clear();
			sessionStorage.clear();
			const parts = location.hostname.split(".");
			const sndleveldomain = parts.slice(-2).join(".");
			document.cookie =
				"congress" + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT";
			document.cookie =
				"token" +
				`=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.${sndleveldomain}`;
			document.cookie =
				"user" +
				`=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.${sndleveldomain}`;
			next();
		} else {
			const path = isMobile() ? "/mAuthServer" : "/authserver/index";
			next(path);
		}
	} else {
		next();
	}
}

/**
 * 检查一个 path 是否属于 auth.routes
 * @param {string} path
 * @return {boolean}
 */
function inAuthRoutes(path) {
	return authRoutes.some(
		(route) =>
			route.path === path ||
			path.includes("/thirdLogin/") ||
			path.includes("/mpassword")
	);
}
